
import { computed, defineComponent, onMounted, ref } from 'vue';
import { OioButton, OioModal, OioMessage } from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'TodBatchUpdatePromotionType',
  components: { OioButton, OioModal },
  props: {
    selectRecords: { type: Array, default: () => [] },
    allRecords: { type: Array, default: () => [] },
    loadPromotionTypeOptions: { type: Function, default: () => [] },
    applyPromotionType: { type: Function, default: () => 0 }
  },
  setup(props) {
    const visible = ref(false);
    const confirmLoading = ref(false);
    const targetType = ref<string | undefined>(undefined);
    const promotionTypeOptions = ref<{ label: string; value: string }[]>([]);

    const tip = computed(() => {
      const selectedCount = props.selectRecords?.length ?? 0;
      if (selectedCount > 0) {
        return `已勾选 ${selectedCount} 条，仅修改勾选行的新促销类型`;
      }
      return `未勾选任何行，将修改全部 ${props.allRecords?.length ?? 0} 条的新促销类型`;
    });

    const openModal = () => {
      targetType.value = undefined;
      visible.value = true;
    };

    const onConfirm = async () => {
      if (!targetType.value) {
        OioMessage.warning('请选择促销类型');
        return;
      }
      confirmLoading.value = true;
      try {
        const count = await props.applyPromotionType(targetType.value);
        if (!count) {
          OioMessage.warning('没有可修改的数据');
          return;
        }
        OioMessage.success(`已修改 ${count} 条数据的新促销类型`);
        visible.value = false;
      } finally {
        confirmLoading.value = false;
      }
    };

    onMounted(async () => {
      try {
        promotionTypeOptions.value = (await props.loadPromotionTypeOptions()) ?? [];
      } catch {
        OioMessage.error('促销类型加载失败，请刷新后重试');
      }
    });

    return { visible, confirmLoading, targetType, promotionTypeOptions, tip, openModal, onConfirm };
  }
});
